import useSWR from 'swr';
import { endpoints, fetcher } from 'services';
import { useState } from 'react';
import useMyInfo from './useMyInfo';
import { PAGE_ITEM_COUNT } from 'commons/constants';

const useRecommends = (recommendHookProps?: {
  /** 한 페이지에 보여줄 아이템 개수 */
  pageItemSize?: number;
  /** 페이지 정렬 정보 */
  sortInfo?: {
    /** 정렬 필드명 */
    sortField: string;
    /** 정렬 방향 */
    sortDirection: 'asc' | 'desc';
  }
}) => {
  const { info } = useMyInfo();
  const [searchOptions, setSearchOptions] = useState<any>({
    size: recommendHookProps?.pageItemSize || PAGE_ITEM_COUNT,
    sort: recommendHookProps?.sortInfo ? `${recommendHookProps?.sortInfo.sortField},${recommendHookProps?.sortInfo.sortDirection}` : 'postDt,desc',
    page: 1,
  });

  // searchOptions를 직렬화하여 SWR key로 사용 (객체 참조 변경 시에도 내용이 같으면 중복 호출 방지)
  const swrKey = info ? [endpoints.recommends.recommends, JSON.stringify(searchOptions)] : null;
  
  const { data } = useSWR<any>(swrKey, () =>
    fetcher.recommends.getRecommends(searchOptions).then(res => {
      return res;
    })
  );

  const { data: keywordData } = useSWR<any>(info ? endpoints.recommends.keywords : null, () =>
    fetcher.recommends.getRecommendKeywords().then(res => res)
  );

  return {
    data,
    searchOptions,
    setSearchOptions,
    keywordData,
  };
};

export default useRecommends;
